import { TypedDocumentNode, gql } from '@apollo/client';

export type UpdateUserProfileMutationVariables = {
  profileId?: number;
  userData?: {
    country?: string | null;
  };
};

export type UpdateUserProfileMutationResponse = {
  update_lager_treyd_auth_profile_by_pk: {
    user_id: number;
  };
};
export const updateUserProfileMutation = gql`
  mutation updateUserProfile(
    $profileId: bigint!
    $userData: lager_treyd_auth_profile_set_input!
  ) {
    update_lager_treyd_auth_profile_by_pk(
      pk_columns: { id: $profileId }
      _set: $userData
    ) {
      user_id
    }
  }
` as TypedDocumentNode<
  UpdateUserProfileMutationResponse,
  UpdateUserProfileMutationVariables
>;
